<template>
    <div>
        <b-modal size="xl" :id="modalId" :ref="modalId">
            <div class="card-body d-flex flex-column">
                <b-row v-if="Object.keys(rmaLine).length > 0">
                    <b-col cols="1">
                        <dt>Vendor</dt>
                        <dd>{{ rmaLine.vendorName }}</dd>
                    </b-col>
                    <b-col cols="1">
                        <dt>RMA Id</dt>
                        <dd>{{ rmaLine.id }}</dd>
                    </b-col>
                    <b-col cols="1">
                        <dt>RMA Date</dt>
                        <dd>{{ date(rmaLine.rmaDate) }}</dd>
                    </b-col>
                    <b-col cols="1">
                        <dt>Buyer</dt>
                        <dd>{{ rmaLine.salesPersonUserFullName }}</dd>
                    </b-col>
                </b-row>
                <br/>
                <div>
                    <grid-component
                        isResizable
                        isReorderable
                        :gridId="gridId"
                        :fields="fields"
                        :itemData="itemData"
                        :handleRowClick="onRowClicked"
                    />
                </div>
            </div>
            <template slot="modal-footer">
                <b-row class="mr-auto ml-3">
                    <add-vrma-component
                        :poNumber="rmaLine.purchaseOrderId"
                        :companyName="rmaLine.vendorName"
                        :rmaLineId="rmaLine.id"
                        />
                </b-row>
                <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
                <b-button variant="primary" :disabled="selectedRowItemId == 0 || isSaving" @click="addToVrma">
                  <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Add to Vendor RMA</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import { prepareColumnsData } from '@/shared/helpers';
import { date } from '@/shared/filters';
import gridFields from './fields';
import AddVrmaComponent from '../index';

export default {
    components: {
        GridComponent,
        AddVrmaComponent
    },
    props: {
        rmaLine: {
            type: Object,
            default: () => {}
        },
        vendorId: {
            type: [Number, String],
            default: 0
        },
        rmaId: {
            type: [Number, String],
            default: 0
        }
    },
    data: () => ({
        fields: gridFields,
        prepareColumnsData,
        selectedRowItemId: 0,
        date,
        modalId: 'create-vrma-from-rma',
        isSaving: false,
        gridId:'add-rma-modal-grid'
    }),
    filters: {
        date
    },
    computed: {
        ...mapGetters('account', ['gridSettingsById']),
        ...mapGetters('vendorrmas', ['pendingVrmaList']),
        gridSettings() {
            return this.gridSettingsById(this.gridId);
        },
        itemData() {
            return this.pendingVrmaList.map((item) => ({ ...item, selected: item.id === this.selectedRowItemId }));
        },
    },
    methods: {
        ...mapActions('account', ['saveGridSettings']),
        ...mapActions('vendorrmas', ['getPendingVrma', 'onSaveVRMALine']),
        onRowClicked(e) {
            this.selectedRowItemId = e.dataItem.id;
        },
        async createVendorRma() {
            this.$bvModal.show('add-vendor-rma');
            this.$bvModal.hide('create-vrma-from-rma');
        },
        async addToVrma() {
            console.log(this.rmaLine, 'RMA Line')
          try {
            this.isSaving = true;
            await this.onSaveVRMALine({
              vendorRmaId: this.selectedRowItemId,
              purchaseOrderLineId: this.rmaLine.poLineId,
              purchaseOrderId: this.rmaLine.purchaseOrderId,
              rmaLineId: this.rmaLine.id,
              items: [{
                inventoryId: this.rmaLine.inventoryId,
                qtyReturning: this.rmaLine.qtyReturning,
                reasonId: this.rmaLine.rmaReasonId,
                comments: 'Added via RMA Line'
              }]
            }).then(() => {
              this.isSaving = false;
              this.$bvModal.hide(this.modalId);
              this.$snotify.success('Created Vendor RMA Line', 'Vendor RMA Line');
              this.$router.push({
                name: 'vendorrmas.edit',
                params: {id: this.selectedRowItemId},
              });
            });
          }catch (e) {
            this.isSaving = false;
            /*console.log(e.message);*/
          }
        }
    },
    watch: {
        async vendorId() {
            await this.getPendingVrma(this.vendorId);
        }
    },
}
</script>
<style scoped>
.create-po-grid {
    height: auto !important;
}
</style>
